import { render } from "./OurScoresPage.vue?vue&type=template&id=6c170f2e&scoped=true"
import script from "./OurScoresPage.vue?vue&type=script&lang=js"
export * from "./OurScoresPage.vue?vue&type=script&lang=js"

import "./OurScoresPage.vue?vue&type=style&index=0&id=6c170f2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c170f2e"]])

export default __exports__